import { without } from 'lodash';
import { labeled, enumRequired } from '../../util/joi';
import { schema as objectiveTypeBaseReasonPrincipalAndInterest } from './ObjectiveTypeBaseReasonPrincipalAndInterest.schema';
import { ImportantOption, importantOptions } from '../global/ImportantOption.enum';
import { PaymentFrequency, paymentFrequencies } from '../global/PaymentFrequency.enum';

export const schema = (Joi: any, label: string) => {
  const availableImportantOptions = without(
    importantOptions,
    ImportantOption.none.name,
    ImportantOption.most_important.name,
    ImportantOption.somewhat_important.name,
    ImportantOption.least_important.name
  );
  const availablePaymentFrequencies = without(
    paymentFrequencies,
    PaymentFrequency.none.name,
    PaymentFrequency.quarterly.name,
    PaymentFrequency.semiannual.name,
    PaymentFrequency.annually.name
  );
  return Joi.object()
    .keys({
      type: enumRequired(
        Joi,
        availableImportantOptions,
        labeled(label, 'Principal and interest')
      )
    })
    .when(
      Joi.object({
        type: Joi.object().keys({ name: Joi.string().valid(ImportantOption?.important?.name) })
      }),
      {
        then: Joi.object({
          preferredPaymentFrequency: enumRequired(
            Joi,
            availablePaymentFrequencies,
            labeled(label, 'Indicate preferred repayment frequency')
          ),
          reason: objectiveTypeBaseReasonPrincipalAndInterest(
            Joi,
            labeled(label, 'Where principal and interest is important, why? - ')
          )
        })
      }
    );
};

export default {
  schema
};
